var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"thermometer"}},[_c('div',{attrs:{"id":"bar-bg"}}),_c('div',{style:(_vm.style),attrs:{"id":"bar"}}),_c('img',{attrs:{"src":require("../assets/thermometer.svg")}})])}
var staticRenderFns = []

export { render, staticRenderFns }